import React from 'react';
import { DateTimePicker as MuiDateTimePicker, DateTimePickerProps } from '@material-ui/pickers';

const DateTimePicker = React.forwardRef<HTMLDivElement, DateTimePickerProps>((props: DateTimePickerProps, ref) => {
  return <MuiDateTimePicker {...props} />;
});

export default DateTimePicker;
